const FormGroup = ({ children, className, ...props }) => {
    return (
        <div className={'form-group ' + (className || '')} {...props}>
            {children}
        </div>
    )
}

export default FormGroup